@if (accountExtensionItems.length > 0) {
  <ul>
    @for (extension of accountExtensionItems; track extension) {
      <li>
        <div class="extension-list-item-wrapper">
          <div class="account-extension-name">{{ extension.number }} - {{ extension.name }}</div>
          <div class="account-extension-name">{{ extension.type.displayName | addSpaces }}</div>
          <div class="extension-details">
            <span #buttonWrapper>
              <button
                type="button"
                title="Extension Details"
                mat-icon-button
                (click)="onDetailsClick(extension, buttonWrapper)"
                >
                <mat-icon>{{
                  selectedExtensionNumber === extension.number ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                }}</mat-icon>
              </button>
            </span>
          </div>
          <button type="button" mat-icon-button (click)="onEditClick(extension)"><mat-icon>edit</mat-icon></button>
          <button type="button" title="Remove Extension" mat-icon-button (click)="onRemoveClick(extension)">
            <mat-icon class="remove-btn">close</mat-icon>
          </button>
        </div>
      </li>
    }
  </ul>
} @else {
  <span class="no-extensions-label">No extensions added</span>
}
